import { render, staticRenderFns } from "./HelpCard.vue?vue&type=template&id=c4993506&scoped=true"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"
import style0 from "./HelpCard.vue?vue&type=style&index=0&id=c4993506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4993506",
  null
  
)

export default component.exports